import React from 'react'

function HeaderClass({ children }) {
    return (
        <div className='headerClass-main'>
            <p>{children}</p>
        </div>
    )
}

export default HeaderClass
